import Vue from 'vue'
import Vuex from 'vuex'
import api from './modules/api'
import { ServiceAccounts } from '@/services/Accounts'
import { updateAuthTokens } from '@/utils/cookies'
import { api as apiApp } from '@/services/api'

export default function (app) {
  Vue.use(Vuex)
  app.store = new Vuex.Store({
    modules: { api },
    state: {
      currentEmployee: undefined,
      currentUser: undefined,
      permissions: {},
      // default site params (getting when app start)
      globalParameters: { copyrights: '', description: '', slogan: '', subTitle: '', title: '', version: '' },
      emailDomains: undefined,
      routeFrom: [],
      L10n: {}
    },
    getters: {
      get: (state) => (type, id) => {
        if (id !== undefined) {
          return (state[type] && state[type][id]) ? state[type][id] : null
        } else {
          if (!(type in state)) Vue.set(state, type, undefined)
          return state[type]
        }
      },
      isHighPermission (state) {
        let highRoleID = [1, 2]
        return highRoleID.some((roleID) => state.permissions['id'] === roleID)
      }
    },
    mutations: {
      set (state, { value, key }) {
        state[key] = value
      },
      setValue (state, { item, type, key }) {
        state[type] = { ...state[type], [key]: item }
      },
      push (state, { item, type }) {
        state[type].push(item)
      }
    },
    actions: {
      // APP
      async accountGeneratePassword ({ commit }, payload) {
        await ServiceAccounts.generatePassword(payload)
      },
      async accountLogin ({ commit }, payload) {
        const { data: { expires, jwt: { token, refreshToken } } } = await ServiceAccounts.loginWithCode(payload)
        updateAuthTokens({ token, refreshToken, expires })
      },
      async accountLogout () {
        await ServiceAccounts.logout()
        updateAuthTokens()
      },
      async getCurrentEmployee ({ state, commit }) {
        return new Promise((resolve, reject) => {
          if (state.currentUser && state.currentUser.employeeID) {
            apiApp
              .get(`Employees/Get/${state.currentUser.employeeID}`, { requestId: 'GetCurrentEmployee' })
              .then((response) => {
                commit('set', { value: response.data, key: 'currentEmployee' })
              })
              .catch(reject)
          } else {
            resolve()
          }
        })
      },
      async getCurrentAppUser ({ commit, dispatch }) {
        const response = await ServiceAccounts.getCurrentAppUser()
        commit('set', { value: response.data, key: 'currentUser' })
        commit('set', { value: response.data.role || {}, key: 'permissions' })
        dispatch('getCurrentEmployee')
      },
      async checkLogged ({ dispatch, state }) {
        if (!state.currentUser) {
          return dispatch('getCurrentAppUser')
        } else {
          return state.currentUser
        }
      },
      load ({ commit }, params) {
        apiApp
          .get(params.url, { params: params.query })
          .then(response => {
            if (response.data) {
              let result = {
                records: response.data.value || [],
                map: {}
              }
              result.records.forEach((item, index) => {
                item.order_ = index
                result.map[item.id] = item
              })
              if (params.callback && params.callback instanceof Function) params.callback(result)
              commit('set', { value: result, key: params.key })
            } else {
              // new Noty({
              //   type: 'error',
              //   text: (response.data.Message || 'Не удалось загрузить данные') + ' (' + params.url + ')'
              // }).show()
            }
          })
      }
    }
  })
}
